import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchCompanyCodes = async periodName => await fetch(
  Config.endpoints.FETCH_COMPANY_CODES_ADMIN
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching company codes data failed' }))
  .then(parseAsJson);

export const fetchBusinessDescriptionsForImport = async companyCodes => await fetch(
  Config.endpoints.FETCH_BUSINESS_DESCRIPTIONS_FOR_IMPORT,
  {
    method: 'POST',
    body: JSON.stringify(companyCodes),
  }
)
  .then(handleErrors({ errorMessage: `Fetching Business Descriptions failed` }))
  .then(parseAsJson);

export const importCompanyCodes = async (companyCodes, periodName) => await fetch(
  Config.endpoints.ADMIN_IMPORT_COMPANY_CODES,
  {
    method: 'POST',
    body: JSON.stringify({ companyCodes, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Company Codes failed' }));

export const fetchFormControlLookupData = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_COMPANY_CODE_ADMIN_FORM_CONTROL_DATA
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching form control data failed' }))
  .then(parseAsJson);

export const refreshObligations = () => fetch(
  Config.endpoints.REFRESH_OBLIGATIONS
)
  .then(handleErrors({ errorMessage: 'Refreshing obligations failed.' }));
